<template>
	<div class="arena-home">
		<!-- TODO: remove import svgIcons after dev -->
		<svgIcons class="hide"></svgIcons>
		<HeroBanner :stickied="stickied"></HeroBanner>
		<GameFilter
			:filters="filters"
			:selected-filter="selectedFilter"
			:stickied="stickied"
			@setFilter="setFilter"
			@setSticky="setSticky"
		></GameFilter>
		<GameList v-if="selectedGameList.length > 0" :game-list="selectedGameList" :filter="selectedFilter"></GameList>
		<LauncherInfo></LauncherInfo>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import HeroBanner from './hero-banner/index';
import GameFilter from './game-filter/index';
import GameList from './game-list/index';
import LauncherInfo from './launcher-info/index';
import svgIcons from '@arena/toolkit/src/components/common/icon-sprite';

export default {
	name: 'Home',
	components: {
		HeroBanner,
		GameFilter,
		GameList,
		LauncherInfo,
		svgIcons,
	},
	data() {
		return {
			games: {
				all: [],
				pc: [],
				mac: [],
				xbox: [],
				psn: [],
				ios: [],
				android: [],
			},
			filters: [
				{ name: 'all', sortable: false },
				{ name: 'pc', sortable: false },
				{ name: 'mac', sortable: false },
				{ name: 'xbox', sortable: false },
				{ name: 'psn', sortable: false },
				{ name: 'ios', sortable: false },
				{ name: 'android', sortable: false },
			],
			selectedFilter: 'all',
			stickied: false,
		};
	},
	computed: {
		...mapState(['heroBannerList', 'gameList']),
		selectedGameList() {
			return this.games[this.selectedFilter];
		},
	},
	mounted() {},
	async created() {
		this.getGameList().then(this.processGameList);
		this.getHeroBannerList();
	},
	methods: {
		...mapActions(['getGameList', 'getHeroBannerList']),
		setFilter(filter) {
			this.selectedFilter = filter;
		},
		setSticky(stickied) {
			this.stickied = stickied;
		},
		processGameList() {
			const len = this.gameList.length;
			for (let i = 0; i < len; i++) {
				const game = this.gameList[i];
				if (game.showInAllGamesPage) {
					this.games.all.push(game);
					this.filters[0].sortable = true;
					if (game.pc || game.steam) {
						this.games.pc.push(game);
						this.filters[1].sortable = true;
					}
					if (game.pcMac) {
						this.games.mac.push(game);
						this.filters[2].sortable = true;
					}
					if (game.xbox) {
						this.games.xbox.push(game);
						this.filters[3].sortable = true;
					}
					if (game.psn) {
						this.games.psn.push(game);
						this.filters[4].sortable = true;
					}
					if (game.ios) {
						this.games.ios.push(game);
						this.filters[5].sortable = true;
					}
					if (game.android) {
						this.games.android.push(game);
						this.filters[6].sortable = true;
					}
				}
			}
		},
	},
};
</script>

<style lang="less">
.main {
	.region-switcher {
		.region-switcher-container {
			position: absolute;
			z-index: 200;
			padding: 40px 30px 30px 30px;
			@media (max-width: 1024px) {
				padding-top: 42px;
			}
			width: 540px;
			@media (max-width: 1024px) {
				width: 375px;
			}
			border-radius: 4px;
			top: 89px;
			right: 60px;
			@media (max-width: 1024px) {
				top: 51px;
				right: 0px;
			}
			.close-x-container {
				.close-x {
					top: 20px;
					right: 31px;
				}
			}
			.btn-region {
				width: 235px;
				height: 50px;
				@media (max-width: 1024px) {
					width: 315px;
				}
				margin-left: 5px;
				margin-right: 0;
				&.primary {
					margin-left: 0;
					margin-right: 5px;
				}
				@media (max-width: 1024px) {
					margin-left: 0;
					margin-right: 0;
					margin-top: 5px;
					&.primary {
						margin-left: 0;
						margin-right: 0;
						margin-bottom: 5px;
					}
				}
			}
			.region-prompt {
				text-align: left;
				margin-bottom: 36px;
				@media (max-width: 1024px) {
					margin-bottom: 34px;
				}
			}
		}
	}
}

.arena-home {
	height: 100%;
	overflow: hidden;
	padding-top: 56px;
	width: 100%;
}
</style>
